<script setup lang="ts">
  import type { ClpStoryblok } from '@/storyblok/component-types-sb'
  import { getStoryblokImageURL } from '@/utils/storyblok/assetsHelper'
  import type { ICampaignDates } from '@/components/campaign/banner/types'

  const props = defineProps<{
    blok: ClpStoryblok
  }>()

  const dayjs = useDayjs()

  const { getCurrentTime } = useCurrentTime()
  const currentTime = await getCurrentTime()

  const endDate = dayjs(props.blok.book_date_end)
  const isCampaignActive = ref(endDate.isAfter(currentTime, 'seconds'))

  const activeContent = computed(() => (isCampaignActive.value ? props.blok.activeBody : props.blok.endedBody))

  const { isDesktop } = useBTBreakpoints()
  const bgImageStyle = computed(() =>
    !isCampaignActive.value && isDesktop.value && props.blok.bgImage?.filename
      ? `background: url('${getStoryblokImageURL(props.blok.bgImage?.filename)}') center center / cover no-repeat;`
      : ''
  )

  provide<ICampaignDates>('campaignDates', {
    book_date_start: props.blok.book_date_start,
    book_date_end: props.blok.book_date_end,
    travel_date_start: props.blok.travel_date_start,
    travel_date_end: props.blok.travel_date_end,
    updatedIsCampaignActive: (isActive: boolean) => {
      isCampaignActive.value = isActive
    },
    currentTime: currentTime,
    show_timer: props.blok?.show_timer ?? false
  })
</script>
<template>
  <section class="relative flex flex-col gap-6 pt-4 md:gap-10 md:pt-8 xl:pt-10">
    <div
      v-if="bgImageStyle.length"
      class="absolute size-full"
      :style="bgImageStyle"
    />
    <div class="relative mb-10 flex flex-col justify-start md:mb-18 md:flex-row">
      <section class="order-0 flex min-w-0 grow flex-col md:order-1">
        <template
          v-for="body in activeContent"
          :key="body._uid"
        >
          <StoryblokComponent
            v-editable="body"
            :blok="body"
          />
        </template>
      </section>
    </div>
  </section>
</template>
